import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgSettingsEmail({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M1.5 6.54L6.6 9.8a2.6 2.6 0 002.8 0l5.1-3.27v4.96c0 .83-.67 1.5-1.5 1.5H3a1.5 1.5 0 01-1.5-1.5V6.54zM13 3c.83 0 1.5.67 1.5 1.5v.61l-5.74 3.7c-.46.3-1.06.3-1.52 0L1.5 5.1v-.6C1.5 3.67 2.17 3 3 3h10z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgSettingsEmail.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgSettingsEmail.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgSettingsEmail svgRef={ref} {...props} />);
export default ForwardRef;
